export default {
  apple_pay: {
    name: 'Apple Pay',
    logo: 'apple',
    benefits: [
      'Easy and private payments with Face/Touch ID',
      'Keeps your financial info safe with end-to-end encryption',
      'Protected by Apple Pay\'s unique Device Account Number'
    ],
  },
  paypal: {
    name: 'PayPal',
    logo: 'paypal',
    benefits: [
      'Fast, convenient payment option',
      'Keeps your financial info safe with end-to-end encryption',
      'Backed by PayPal\'s industry-leading fraud protection'
    ],
  },
  card: {
    name: 'Credit Card',
    logo: 'card',
    button: 'Confirm purchase'
  },
  secure: 'Your payment information is secure with SSL/TLS encryption'
}
